import { useResource } from '@landsbankinn/l16n';
import React from 'react';
import type { INumberFormatInputProps } from './NumberFormatInput';
import { NumberFormatInput } from './NumberFormatInput';

interface IProps extends INumberFormatInputProps {
  onChangeValue: (value: number) => void;
}

export const MoneyInput: React.FC<IProps> = ({
  onChangeValue,
  hideSuffix,
  suffix = ' kr.',
  value,
  ...rest
}: IProps) => {
  const { locale } = useResource();
  return (
    <NumberFormatInput
      isAllowed={({ floatValue }) => {
        return (
          floatValue === undefined || (floatValue >= 0 && floatValue < 10e8)
        );
      }}
      onChange={(e) => {
        /* We use on change because onValueChange triggers when value prop changes, creating a loop */
        onChangeValue(
          parseFloat(
            locale === 'is'
              ? e.currentTarget.value.replace(/\./g, '').replace(/,/g, '.')
              : e.currentTarget.value.replace(/,/g, ''),
          ),
        );
      }}
      displayType="input"
      allowEmptyFormatting
      suffix={suffix}
      hackSuffix={!hideSuffix ? suffix : undefined}
      value={value}
      {...rest}
    />
  );
};
